import { logout } from 'redux/features/userSliceWithTokenValidation';
import { rxdApi } from 'actions/rtkquery';
import { persistor } from 'redux/store';
import { LOGIN_PATH } from 'routes/navigation/navigationPaths';

/**
 * Déconnexion complète et sécurisée.
 * Purge tous les stockages client (LocalStorage, SessionStorage, IndexedDB),
 * réinitialise le cache API et l'état Redux, puis effectue une redirection
 * complète (hard reload) vers la page de login pour garantir l'absence de résidus en mémoire.
 */
export const performLogout = async (dispatch) => {
  try {
    localStorage.clear();
    sessionStorage.clear();
    if (typeof window !== 'undefined' && window.indexedDB) {
      try {
        window.indexedDB.deleteDatabase('rxd-storage');
      } catch (e) {
        /* noop */
      }
    }
  } catch (e) {
    /* noop */
  }

  try {
    if (dispatch) {
      dispatch(rxdApi.util.resetApiState());
      await dispatch(logout());
    }
    if (persistor && persistor.purge) {
      await persistor.purge();
    }
  } catch (e) {
    /* noop */
  }

  if (typeof window !== 'undefined') {
    window.location.href = LOGIN_PATH;
  }
};
